var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-select',{attrs:{"value":_vm.value,"fancy":"","label":_vm.$ct('components.products.csv-import-product-matching-method-label'),"items":_vm.productMatchingMethods},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }